<script setup>
import { ref } from 'vue';
import Combobox from "@/components/ui/Combobox.vue";
import { Dialog, DialogScrollContent, DialogTrigger, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

const props = defineProps({
  action: {
    type: String,
    required: true
  },
  exponents: {
    type: Array,
    required: true
  },
})
</script>

<template>
  <div>
    <Dialog>
      <DialogTrigger class="btn btn-primary">
        {{ $t('Add Exponent') }}
      </DialogTrigger>
      <DialogScrollContent ref="select2Contrainer">
        <DialogHeader>
          <DialogTitle>
            {{ $t('Select an exponent') }}
          </DialogTitle>
        </DialogHeader>
        <form method="POST" :action="action">
          <slot></slot>
          <div class="form-group">
            <label for="exponent-combo">{{ $t('Select exponent to add') }}</label>
            <Combobox
              id="exponent-combo"
              name="exponent"
              :options="exponents.map(exponent => ({ value: exponent.id, label: exponent.text }))"
              :fullwidth="true"
            />
          </div>
          <div class="form-group form-check">
            <input type="checkbox" class="form-check-input" id="frmAddExponentAsGuest" name="as_guest" value="1">
            <label class="form-check-label" for="frmAddExponentAsGuest">{{ $t('As guest') }}</label>
          </div>
          <DialogFooter>
            <button type="submit" class="btn btn-primary">{{ $t('Add Exponent') }}</button>
          </DialogFooter>
        </form>
      </DialogScrollContent>
    </Dialog>
  </div>
</template>
